import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProjectService } from 'src/app/services/project.service';
import { TaskService } from 'src/app/services/task.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import CustomStore from 'devextreme/data/custom_store';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'ng-uikit-pro-standard';
import { SalesProjectService } from 'src/app/services/sales-project.service';
import { EmployeesService } from 'src/app/services/employees.service';
import { DriveserviceService } from 'src/app/services/driveservice.service';
import { MapInformationService } from 'src/app/services/map-information.service';
@Component({
  selector: 'app-new-progress-report',
  templateUrl: './new-progress-report.component.html',
  styleUrls: ['./new-progress-report.component.scss']
})
export class NewProgressReportComponent implements OnInit {

  @Input() popupComments = false;
  @Input() projectid = 0;
  @Input() idPR = undefined;
  @Output() onmodalhidden = new EventEmitter<any>();
  @Output() onsubmit = new EventEmitter<any>();

  hasproject = false;
  cancelButton: any;
  saveButton: any;

  //Editor HTML
  bodyHtml: any = "";
  bodyhtmlrecibido: any = "";
  itemsEditorTurnOverSheet: any = [

    "undo", "redo", "separator",

    {
      name: "size",
      acceptedValues: ["8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt"]
    },
    {
      name: "font",
      acceptedValues: ["Arial", "Courier New", "Georgia", "Impact", "Lucida Console", "Tahoma", "Times New Roman", "Verdana"]
    },

    "separator", "bold", "italic", "strike", "underline", "separator",
    "alignLeft", "alignCenter", "alignRight", "alignJustify", "increaseIndent",
    "decreaseIndent", "separator",
    "orderedList", "bulletList", "separator",

    {
      name: "header",
      acceptedValues: [false, 1, 2, 3, 4, 5]
    },

    "color","background","link", "clear","codeBlock","blockquote", "separator", "insertTable","deleteTable",
    "insertRowAbove","insertRowBelow","deleteRow","insertColumnLeft","insertColumnRight",
    "deleteColumn","cellProperties","tableProperties",
  ];

  private _info: any;

  disableIconLink: boolean = false;
  DocumentsButton: { text: string; icon: string; elementAttr: { id: string; }; onClick: () => void;};
  showNew:boolean = true
  @Input('info')
  set info(info: any) {
    this._info = info;
    console.log('Data en Edit ', info);
    if (info.AllData != undefined){
      if (info.AllData.ATTACHMENT != undefined){
        this.showNew = false
      }
    }
    if (this.formProgressReport && info) {
      console.log(this.idPR)
      this.bodyHtml = info.pdescription;
      this.formProgressReport.get('id').setValue(info.id);
      this.formProgressReport.get('projectid').setValue(info.projectid);
      this.formProgressReport.get('pdescription').setValue(info.pdescription);
      this.hasproject = true;
    }
    // if (info && info.infoid > 0)
    // this.setinfoInfo(info);
  }

  formProgressReport: FormGroup = new FormGroup({
    createdbyid: new FormControl('', []),
    pdescription: new FormControl('', []),
    projectid: new FormControl(this.projectid, []),
    id: new FormControl(0, [])
  });

  projectslist: any;
  popupDocument = false;
  actionDocument = 'New Document';


  constructor(
    private googleDrivePickerService: DriveserviceService,
    private MapInformationService:MapInformationService,
    private salesProjectService: SalesProjectService,
    private projectService: ProjectService,
    private translate:TranslateService,
    private employee: EmployeesService,
    private taskService: TaskService,
    private toast: ToastService,
  ) { }

  ngOnInit() {
    this.cancelButton = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupComments = false;
        this.close();
      },
    };

    this.saveButton = {
      text: this.translate.instant('btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.type = 1;
        this.addNewComment();
      },
    };

    this.DocumentsButton = {
      text: "New Document",
      icon: 'plus',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.type = 1;
        console.log(this.projectid)
        this.popupDocument = true;
        this.actionDocument = 'New Document';
        this.initDocumentForm();
        this.getDocumentType();
        this.getEmployee();
      },
    };

    let mythis = this;
    this.projectslist = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        return mythis.taskService.GetProjectByName(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });
  }

  uploadingFile: boolean;
  _documentForm: FormGroup;
  optionsFile: any[] = ['Upload File to Cube','Select External File'];
  valueOptionsFile = this.optionsFile[0];

  initDocumentForm() {
    this.uploadingFile = true;

    console.log(this._info)

    if (this._info.AllData != undefined){
      this._documentForm = new FormGroup({
        name: new FormControl({ value: this._info.AllData.NAME, disabled: false }, [Validators.required]),
        documenttypeid: new FormControl({ value: this._info.AllData.DOCUMENTTYPEID, disabled: false }, [Validators.required]),
        documentrevision: new FormControl({ value: this._info.AllData.REVISION, disabled: false }, [Validators.required]),
        revisionnotes: new FormControl({ value: this._info.AllData.REVISIONNOTES, disabled: false }, []),
        description: new FormControl({ value: this._info.AllData.DESCRIPTION, disabled: false }, []),
        attachment: new FormControl({ value: this._info.AllData.ATTACHMENT, disabled: false }, []), //Nombre de file con extensión
        projectid: new FormControl({ value: this.projectid, disabled: false }, []),
        optionFile: new FormControl({ value: this.valueOptionsFile, disabled: false }, []),
        id: new FormControl({ value: this._info.AllData.DOC_ID == undefined ? 0 : this._info.AllData.DOC_ID, disabled: false }, []),
        restricted: new FormControl({ value: false, disabled: false }, []),
      });
      this._documentForm.addControl('hyperlink', new FormControl({ value: this._info.AllData.HYPERLINK, disabled: false }, []))
      let upload;
      this.selectedTabPopup = 0
      if(this._info.AllData.ATTACHMENT !='' && this._info.AllData.ATTACHMENT != undefined){
        this.uploadingFile = true;
        this.MapInformationService.GetDocument(this._info.AllData.FILEPATH).subscribe(result => {
          let typeMime=[]

          if(this._info.AllData.ATTACHMENT != undefined && this._info.AllData.ATTACHMENT != null){
            typeMime = this._info.AllData.ATTACHMENT.toString().split(".")
          } else {
            typeMime = ["","document"]
          }

          this.File = new File ([result.filestring], this._info.AllData.ATTACHMENT, {type:typeMime[1]});
          if(this.File!==null){

            this._documentForm.get('attachment').setValue(this.File.name);
            this.valueDocument = [this.File]
            this.attachment = result.filestring
            this.selectedFile = result.filestring
            this.changeBase64 = false;
          }
        })
        this.selectedTabPopup = 0;
        this.valueOptionsFile = this.optionsFile[0];
      }else{
        // this.selectedTabPopup = 1;
      }
      this.externalLink = this._info.AllData.HYPERLINK;

    } else {
      this._documentForm = new FormGroup({
        name: new FormControl({ value: '', disabled: false }, [Validators.required]),
        documenttypeid: new FormControl({ value: "", disabled: false }, [Validators.required]),
        documentrevision: new FormControl({ value: null, disabled: false }, [Validators.required]),
        revisionnotes: new FormControl({ value: '', disabled: false }, []),
        description: new FormControl({ value: '', disabled: false }, []),
        attachment: new FormControl({ value: '', disabled: false }, []), //Nombre de file con extensión
        projectid: new FormControl({ value: this.projectid, disabled: false }, []),
        optionFile: new FormControl({ value: this.valueOptionsFile, disabled: false }, []),
        id: new FormControl({ value: 0, disabled: false }, []),
        restricted: new FormControl({ value: false, disabled: false }, []),
      });
    this._documentForm.addControl('hyperlink', new FormControl({ value: '', disabled: false }, []))

    }

  }

  documentTypeSelect:any[]=[]

  getDocumentType() {
    this.salesProjectService.GetProjectDocumentType().subscribe(result => {
      this.documentTypeSelect = result;
    });
  }

  employeeSelect:any[]=[]

  getEmployee() {
    this.employee.GetAll().subscribe(result => {
      this.employeeSelect = result.map((val) => {
        return { // Return the new object structure
          label: val.CONTACTNAME,
          value: val.ID
        };
      });
    });
  }


  updateProjectInfo(ev) {
    console.log(ev);
    if(ev.selectedItem)
      this.formProgressReport.get('projectid').setValue(ev.selectedItem.ID);
    else
    this.formProgressReport.get('projectid').setValue(0);
  }

  close() {
    console.log("CERRANDO POPUP??")
    this.popupComments = false;
    this.onmodalhidden.emit();
    this.initForm();
    this.hasproject = false;
  }

  initForm() {
    this.formProgressReport = new FormGroup({
      createdbyid: new FormControl('', []),
      pdescription: new FormControl('', []),
      projectid: new FormControl(0, []),
      id: new FormControl(0, [])
    });

  }

  //Progress Report
  addNewComment(){
    let form = this.formProgressReport.value;
    // form.projectid = this.projectid;
    
    form.pdescription = this.bodyHtml;

    if (!form.projectid || form.projectid ==0) {
      this.toast.warning(this.translate.instant('msgSelProj'));
      return;
    }

    form.createdbyid = localStorage.getItem('customerid');
    console.log('FORM ', form);
    this.projectService.InsertProgressReport(form).subscribe(result=>{

      this.idPR = result[0].ID
      this.toast.success(this.translate.instant('msgRepUpdSucc'));
      // this.popupComments = false;
      this.onsubmit.emit();
      this.close();
      // this.getProgressReport();
    })
  }

  //Editor HTML
  asignarValue(event){
    let search = event.value.includes('href=');
    let separado = event.value.split('href="');
    if(search !== -1 && separado.length > 1){
      console.log('Separado ', separado);

      for (let i = 1; i < separado.length; i++) {
        console.log('Test ', separado[i].substr(0,2));
        if(separado[i].substr(0,2) !== '//' && separado[i].substr(0,5) !== 'https'){
          separado[i] = 'href="//' + separado[i];
        }else{
          separado[i] = 'href="' + separado[i];
        }
        console.log(separado[i]);
      }

      console.log('AQUI FINAL ? ', separado);
      
      this.bodyHtml = separado.join(' ');
    }else{
      this.bodyHtml = event.value;
    }

    // console.log('HTML ', this.bodyHtml);
  }

  File:File;
  valueDocument: any[] = [];
  selectedFile: any="";
  attachment:any="";
  showModalDelete:boolean=false
  idDocument:any
  externalLink: any = '';
  selectedTabPopup: any = 0;


  closePopupDocument(){
    this.valueDocument=[];
    this.selectedFile = '';
    this.externalLink = '';
    this.selectedTabPopup = 0;
  }

  submitDocument(saveandnew = false) {
    let form = this._documentForm.value;

    if(this.selectedFile.length == 0 && this.externalLink.length == 0 ){
      this.toast.warning('Select a File to Save');
      return this._documentForm.invalid;
    }

    // form[this.insertDocument.name_id] = this.itemid;

    // if(this.itemid2 != undefined) {
      // form[this.insertDocument.name_id] = this.itemid2;
    // }

    this.projectid!==null && this.projectid!==undefined ? form.projectid = this.projectid : '';

    form.method = "Insert_ProjectAttachment";

    console.log(this.idPR)

    // if(this.itemid2 != undefined) {
    //   form[this.insertDocument.name_id] = this.itemid2;
    // }

    form.doctypeid = form.documenttypeid
    form.restricted = form.restricted == true ? 1 : 0
    form.progressid = this.idPR
    console.log('FORM ', form);
    
    this.salesProjectService.InsertDocuments(form).subscribe(result=>{
      console.log('INSERTED BD ', result);
      this.popupDocument = false;

      if(result[0].ReturnID != undefined) {
        this.salesProjectService.SaveDocumentDinamico(form.name, this.selectedFile, result[0].ReturnID, "projectdoc")
        .subscribe((resp)=>{
          if ((typeof result["result"] != "undefined") && (result["result"].toString() == '0')){
            this.resetFormAfterSubmit();
          }else{
            this.resetFormAfterSubmit();
          }
        },error=>{
          console.log('Error ', error);
          this.toast.error('Error');
        });
      }

      this.externalLink = "";
      this.selectedFile = "";

    },error=>{
      this.resetFormAfterSubmit();
    })
  }

  resetFormAfterSubmit(){
    this.initDocumentForm();
    this.toast.success(this.translate.instant('msgDocInfoUpdSucc'));
    this.selectedFile = '';
    this.valueDocument=[];
    // this.getProjectDocument();
    this.onsubmit.emit();
  }

  NewDocument(){
    this.popupDocument = true;
    this.actionDocument = 'New Document';
    this.initDocumentForm();
    this.getDocumentType();
    this.getEmployee();
    this.valueDocument = []
  }

  changeBase64:boolean= true

  changeFile(ev) {
    if(this.changeBase64 && ev.value[0] && ev.value[0].size < 40000000){
      this._documentForm.get('attachment').setValue(ev.value[0].name);
      this.getBase64(ev.value[0]);
    } else {
      this.changeBase64 = true;
    }
  }

  getBase64(file) {
    const mythis = this
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      let data = reader.result.toString().split(",")
      mythis.attachment = data[1]
      mythis.selectedFile = data[1];
    };
    reader.onerror = function (error) {
    };
  }

  BorrarDocument(){
    this.valueDocument = [];
    this.selectedFile = '';
    this._documentForm.get('attachment').setValue('');
  }

  enableIconLink(e){

    if(e.length > 0){
      this.disableIconLink = true;
    }else{
      this.disableIconLink = false;
    }
    // this.editLinkButton.disabled = this.disableIconLink;
  }

  dominioactual: any;
  modalCookies: boolean = false;

  openGoogleDrivePicker(): void {
    this.googleDrivePickerService.open((data) => {
      if (data.action === 'picked') {
        this.externalLink = data.docs[0].url;
        this._documentForm.get('hyperlink').setValue(data.docs[0].url)
      }else if (data.details == "Cookies are not enabled in current environment."){
        this.dominioactual = document.domain;
        this.modalCookies = true;
      }
    })
  }

}
